import { render, staticRenderFns } from "./TipoDeCalculo.vue?vue&type=template&id=0a762e52"
import script from "./TipoDeCalculo.vue?vue&type=script&lang=js"
export * from "./TipoDeCalculo.vue?vue&type=script&lang=js"
import style0 from "./TipoDeCalculo.vue?vue&type=style&index=0&id=0a762e52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports